export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8268.1104e75d.jpg";